module.exports = __webpack_public_path__ + "static/img/group9.e5bc901.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Probuild/group9.png
// module id = NR1u
// module chunks = 0